export enum WBMessageType {
  SystemMsg = 'system',
  ErrorMsg = 'error',
  AiMsg = 'ai',
  UserMsg = 'user',
  InterruptMsg = 'interrupt',
  WorkflowSavedMsg = 'workflow_saved',
  WorkflowTestMsg = 'workflow_test',
}

export type WBMessage = {
  id?: string
  author?: string
  message: string | any
  type?: WBMessageType
  pass_to_human?: boolean
  thinking?: string
  feedback?: any
  commited?: boolean
  reasoning?: any
  tool_calls?: any
}

export type WorkflowBuilderState = {
  isStreaming: boolean
  messages: WBMessage[]
  pendingAiResponse: boolean
  streamingAiResponse: boolean
  thread_id: string | null
  pendingRequestActionMessage: string | null
  previousUserMessage: string | null
}

export const initialState: WorkflowBuilderState = {
  isStreaming: false,
  messages: [],
  pendingAiResponse: false,
  streamingAiResponse: false,
  thread_id: null,
  pendingRequestActionMessage: null,
  previousUserMessage: null,
}
